import React from "react";
import { Container, Row, Col } from "react-bootstrap";
// import { Linkedin, Github } from "react-bootstrap-icons";
import Card from "react-bootstrap/Card";
import "../App.css";
import logo from "../assets/logo_abhishek.png";
import abhishek from "../assets/abhishek_img.jpeg";
import hsc from "../assets/hsc.png";
import ssc from "../assets/ssc.png";
import university from "../assets/university.png";
import Frontend from "../assets/frontend.png";
import Backend from "../assets/backend.png";
import Database from "../assets/database.png";
import Language from "../assets/language.png";
import wordle from "../assets/wordle-project.png";
import Other from "../assets/other.png";
import MajorProject from "../assets/major-project.png";
import WebBrowser from "../assets/web-browser-project.png";
import Phone from "../assets/phone.png";
import Mail from "../assets/mail.png";
import CinemaHub from "../assets/cinemahub-project.png";
import FunctraDemoGif from "../assets/demo_functra.gif"; // adjust path as needed

// import Background from "../Components/Backround.jsx";

const Page = () => {
  return (
    <>
      <div className="pageBody">
        <Container className="handle-media">
          <div className="hello">
            <center className="logo-box">
              <img className="logo img-fluid" src={logo} alt="logo" />
            </center>
            <center className="hello-info">
              <h1 className="hello-heading">
                <span class="black-text">
                  <i className="cursive-font">Hello,</i>
                </span>
                <span class="brown-text"> I am Abhishek!</span>
              </h1>
              <p className="sub-heading hello-page">
                Backend Developer with 2 years of experience crafting
                scalable, efficient APIs and microservices at Reliance Jio.
                Proficient in FastAPI, Java Spring Boot, and cloud-native tools,
                I build robust backend systems that power impactful healthcare
                solutions. Let&#39;s build something meaningful together.
              </p>
              <button
                class="hire-button"
                onClick={() =>
                  (window.location.href = "mailto:12abhishek10@gmail.com")
                }
              >
                Hire Me
              </button>
            </center>
          </div>

          <div className="about">
            {/* <center> */}
            <Row className="justify-content-center">
              <Col xl={6} md={6} sm={12}>
                <div className="aboutinfo">
                  <h2 className="about-abhishek cursive-font">
                    About Abhishek Sharma
                  </h2>
                  <p className="about-info sub-heading">
                    I&#39;m Abhishek, a Backend Developer with 2 years at Reliance Jio Health Hub, focused on building scalable systems using FastAPI and Spring Boot. I&#39;ve boosted user engagement by 40% with personalized health reminders, reduced API latency by 40%, and improved system performance by 30%. From SSO integration to real-time slot booking, I build backend solutions that deliver real results at scale.
                    <br />
                    <br />
                    Let&#39;s create impact together!
                  </p>
                </div>
              </Col>
              <Col xl={6} md={6} sm={12}>
                <img
                  className="abhishek-pic"
                  src={abhishek}
                  alt="abhishek sitting on chair"
                />
              </Col>
            </Row>
            {/* </center> */}
          </div>

          <div className="background-history">
            <h2 className="background-header cursive-font">Background</h2>
            <Row>
              <Col xl={4} md={6} sm={12}>
                <Card className="card-background-section">
                  <Card.Img
                    className="image-background-section img-fluid"
                    variant="top"
                    src={university}
                  />
                  <Card.Body>
                    <Card.Title className="card-title">
                      University of Mumbai
                    </Card.Title>
                    <hr className="hr-custom" />
                    <Card.Text className="sub-heading">
                      Bachlor of Engineering <br />
                      Information Technology
                      <br /> <b>8.98 c.g.p.a (80%)</b>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col xl={4} md={6} sm={12}>
                <Card className="card-background-section">
                  <Card.Img
                    className="image-background-section img-fluid"
                    variant="top"
                    src={hsc}
                  />
                  <Card.Body>
                    <Card.Title>R.K.Talreja College of Science</Card.Title>
                    <hr className="hr-custom" />
                    <Card.Text className="sub-heading">
                      Completed HSC in 2019 <br />
                      <b>72%</b>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col xl={4} md={6} sm={12}>
                <Card className="card-background-section">
                  <Card.Img
                    className="image-background-section img-fluid"
                    variant="top"
                    src={ssc}
                  />
                  <Card.Body>
                    <Card.Title>St Mary&#39;s High School</Card.Title>
                    <hr className="hr-custom" />
                    <Card.Text className="sub-heading">
                      Completed SSC in 2017 <br /> <b>86.60%</b>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>
          {/* ---------------- Skills Section ----------  */}
          <div className="skills">
            <h2 className="background-header">Skills</h2>
            <Row>
              <Col>
                <Card className="card-background-section">
                  <Card.Img
                    className="image-background-section img-fluid"
                    variant="top"
                    src={Frontend}
                  />
                  <Card.Body>
                    <Card.Title className="card-title">
                      Frontend Technology
                    </Card.Title>
                    <hr className="hr-custom" />
                    <Card.Text className="sub-heading">
                      ReactJS,Bootstrap <br />
                      HTML,CSS
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col>
                <Card className="card-background-section">
                  <Card.Img
                    className="image-background-section img-fluid"
                    variant="top"
                    src={Backend}
                  />
                  <Card.Body>
                    <Card.Title>Backend Technology</Card.Title>
                    <hr className="hr-custom" />
                    <Card.Text className="sub-heading">
                      FastAPI,NodeJS,
                      <br />
                      Java Spring Boot
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col>
                <Card className="card-background-section">
                  <Card.Img
                    className="image-background-section img-fluid"
                    variant="top"
                    src={Database}
                  />
                  <Card.Body>
                    <Card.Title>
                      Database <br /> Technology
                    </Card.Title>
                    <hr className="hr-custom" />
                    <Card.Text className="sub-heading">
                      MySQL,PostgreSQL <br />
                      MongoDB, Redis
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col>
                <Card className="card-background-section">
                  <Card.Img
                    className="image-background-section img-fluid"
                    variant="top"
                    src={Language}
                  />
                  <Card.Body>
                    <Card.Title className="card-title">
                      Programming Languages
                    </Card.Title>
                    <hr className="hr-custom" />
                    <Card.Text className="sub-heading">
                      Python,Java <br />
                      JavaScript
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col>
                <Card className="card-background-section">
                  <Card.Img
                    className="image-background-section img-fluid"
                    variant="top"
                    src={Other}
                  />
                  <Card.Body>
                    <Card.Title className="card-title">
                      Other <br />
                      Technology
                    </Card.Title>
                    <hr className="hr-custom" />
                    <Card.Text className="sub-heading">
                      Git, Github, Postman,
                      <br /> Azure, Docker
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>

          {/* ---------------- Projects Section ----------  */} 
          <div className="project">
            <h1 className="background-header">My Projects</h1>
            {/* <Container> */}
            <Row className="justify-content-center">
              <Col xl={8} md={8} sm={12} xs={12}>
                <div className="project-1">
                  <h2 className="project-header cursive-font">
                    <a
                      href="https://github.com/abhishek-sharma-2001/Major_Project"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Ml Based Indian Unconventional Emission Prediction System
                      For Indian Scenario (Major Project)
                    </a>
                  </h2>
                  <p className="sub-heading project-para">
                    Developed a traffic optimization model using advanced
                    intersections like DDI and RCUT, simulated via PTV Vissim.
                    Integrated real-time traffic data to predict vehicular
                    emissions using ML algorithms. Achieved a 23.6% reduction in
                    delay time and proposed a scalable emission-aware traffic
                    planning system tailored for Indian urban environments.
                  </p>
                </div>
              </Col>
              <Col xl={4} md={4} sm={12}>
                <a
                  href="https://github.com/abhishek-sharma-2001/Major_Project"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="project-1-img img-fluid"
                    src={MajorProject}
                    alt="abhishek's Major Project"
                  />
                </a>
              </Col>
              {/* <hr className="hr-custom hr-margin" /> */}
            </Row>
            <div className="project-5">
              <Row>
                <Col xl={8} md={8} sm={12}>
                  <div className="">
                    <h2 className="project-header cursive-font">
                      <a
                        href="https://marketplace.visualstudio.com/items/?itemName=functra.functra"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Functra - Function Flow Visualizer
                      </a>
                    </h2>
                    <p className="sub-heading project-para">
                      Co-created a VS Code extension to visualize function call
                      flow in Python and FastAPI projects. Enables intuitive
                      graph-based tracing of user-defined functions, fast
                      searching, and PNG exports. Built for performance and
                      offline use, Functra accelerates debugging and onboarding
                      in large-scale or legacy codebases.
                    </p>
                  </div>
                </Col>
                <Col xl={4} md={4} sm={12}>
                  <a
                    href="https://marketplace.visualstudio.com/items/?itemName=functra.functra"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="project-4-img img-fluid"
                      src={FunctraDemoGif}
                      alt="functra demo gif"
                    />
                  </a>
                </Col>
                {/* <hr className="hr-custom hr-margin" /> */}
              </Row>
            </div>
            <div className="project-2">
              <Row>
                <Col xl={8} md={8} sm={12}>
                  <div className="">
                    <h2 className="project-header cursive-font">
                      <a
                        href="https://github.com/abhishek-sharma-2001/Automated-Web-Browser-Chanakya"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Automated web Browser
                      </a>
                    </h2>
                    <p className="sub-heading project-para">
                      Designed a custom web browser with smart tab automation
                      that opens frequently visited websites. Added features
                      like an offline Snake mini-game and robust password
                      detection for enhanced security. Experience a more
                      efficient and enjoyable browsing journey with our
                      innovative features
                    </p>
                  </div>
                </Col>
                <Col xl={4} md={4} sm={12}>
                  <a
                    href="https://github.com/abhishek-sharma-2001/Automated-Web-Browser-Chanakya"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="project-2-img img-fluid"
                      src={WebBrowser}
                      alt="abhishek's Web Browser Project"
                    />
                  </a>
                </Col>
                {/* <hr className="hr-custom hr-margin" /> */}
              </Row>
            </div>
            <div className="project-3">
              <Row>
                <Col xl={8} md={8} sm={12}>
                  <div className="">
                    <h2 className="project-header cursive-font">
                      <a
                        href="https://github.com/abhishek-sharma-2001/wordle-clone"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Wordle Game
                      </a>
                    </h2>
                    <p className="sub-heading project-para">
                      Built a functional replica of the viral Wordle game using
                      HTML, CSS, and vanilla JavaScript. Features real-time
                      input validation, color-coded feedback, and a responsive
                      layout. A fun, logic-based frontend project emphasizing
                      clean UX and game logic implementation.
                    </p>
                  </div>
                </Col>
                <Col xl={4} md={4} sm={12}>
                  <a
                    href="https://github.com/abhishek-sharma-2001/wordle-clone"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="project-3-img img-fluid"
                      src={wordle}
                      alt="abhishek's wordle Project"
                    />
                  </a>
                </Col>
                {/* <hr className="hr-custom hr-margin" /> */}
              </Row>
            </div>
            <div className="project-4">
              <Row>
                <Col xl={8} md={8} sm={12}>
                  <div className="">
                    <h2 className="project-header cursive-font">
                      <a
                        href="https://github.com/abhishek-sharma-2001/moviespremier"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        CinemaHub
                      </a>
                    </h2>
                    <p className="sub-heading project-para">
                      CinemaHub is a dynamic media exploration platform which
                      utilizes React for a responsive frontend, ensuring a
                      seamless user experience. Integrated with a Movie API, it
                      effortlessly fetches and presents diverse content,
                      spanning movies, series, and anime. The platform stands
                      out for its user-friendly interface, offering an immersive
                      and efficient content discovery process.
                    </p>
                  </div>
                </Col>
                <Col xl={4} md={4} sm={12}>
                  <a
                    href="https://github.com/abhishek-sharma-2001/moviespremier"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="project-4-img img-fluid"
                      src={CinemaHub}
                      alt="abhishek's CinemaHub project"
                    />
                  </a>
                </Col>
                {/* <hr className="hr-custom hr-margin" /> */}
              </Row>
            </div>
            {/* </Container> */}
          </div>

          {/* <center>
      <div className="sub-heading footer">Made with &#9829;</div>
      </center> */}
        </Container>
      </div>

      {/* -----------------contacts----------------- */}

      <div className="contact">
        <div className="socials">
          <Row>
            <Col xl={9} md={9} sm={9} xs={12}>
              <h5 className="contact-message">
                Reach out if you want to create impact together.
              </h5>
              <hr className="contact-hr" />
              <h5 className="sub-heading">
                TO SEE MORE OF MY WORK, VISIT MY SOCIALS:
              </h5>

              <a
                className="footer-links"
                href="https://www.linkedin.com/in/abhisheksharma1210"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-linkedin"></i>
              </a>
              <a
                className="footer-links"
                href="https://github.com/abhishek-sharma-2001"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-github"></i>
              </a>
              <a
                className="footer-links"
                href="https://leetcode.com/u/abhishek_12_10/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-code-slash"></i>
              </a>
            </Col>
          </Row>
        </div>
        <div className="phone">
          <Row className="custom-row">
            <Col xl={9} md={7} sm={7} xs={0}></Col>
            <Col xl={3} md={5} sm={5} xs={12}>
              <Row
                onClick={() => (window.location.href = "tel:+91 9819357375")}
              >
                <Col xs={3}>
                  <img src={Phone} className="img-fluid" alt="phone icon" />
                </Col>
                <Col className="cursor">
                  <Row>PHONE</Row>
                  <Row className="sub-heading">+91 9819357375</Row>
                </Col>
              </Row>
              <br />
              <Row
                onClick={() =>
                  (window.location.href = "mailto:12abhishek10@gmail.com")
                }
              >
                <Col xs={3}>
                  <img src={Mail} className="img-fluid" alt="Mail icon" />
                </Col>
                <Col className="cursor">
                  <Row>EMAIL</Row>
                  <Row className="sub-heading">12abhishek10@gmail.com</Row>
                </Col>
              </Row>
            </Col>
          </Row>
          <br />
          <br />
        </div>
      </div>
    </>
  );
};

export default Page;
